import { render } from "./MonitorsListScreen.vue?vue&type=template&id=5114288c"
import script from "./MonitorsListScreen.vue?vue&type=script&lang=js"
export * from "./MonitorsListScreen.vue?vue&type=script&lang=js"

import "./MonitorsListScreen.vue?vue&type=style&index=0&id=5114288c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__